import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"mx-auto nk-follow",attrs:{"height":"200","width":"60"}},[_c(VNavigationDrawer,{attrs:{"absolute":"","dark":"","src":"https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg","width":"100%","permanent":""}},[_c(VList,_vm._l((_vm.items),function([icon, text],i){return _c(VListItem,{key:i,attrs:{"link":""}},[_c(VListItemIcon,[_c(VIcon,[_vm._v(_vm._s(icon))])],1)],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }